import { Fragment, ReactElement, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormAssignOperator from './form';

const OldAssignedOperators = (): ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-old-assign-operator-content"
          id="panel-old-assign-operator-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Precedenti Assegnazioni</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormAssignOperator />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

OldAssignedOperators.displayName = 'Practice Assign - old assign to operator component';

export default OldAssignedOperators;
